import React from "react"
import Ionicon from "react-ionicons"
import {values, get, sortBy, find, findIndex, cloneDeep} from "lodash"
import PropTypes from "prop-types"

import './Reservation.Drinks.less'

export default class DrinksPicker extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { }
  }

  changeCount(drink, count) {
    const selectedDrinks = cloneDeep(this.props.value)
    const drinkStored = find(
      this.props.value, 
      (dr) => drink.id == dr.id
    )
    const drinkStoredIndex = findIndex(
      this.props.value, 
      (dr) => drink.id == dr.id
    )
    const newDrink = {id: drink.id, name: drink.name, count: Math.max(0, get(drinkStored, "count", 0) + count)}
    if (drinkStoredIndex == -1) selectedDrinks.push(newDrink) 
    else selectedDrinks[drinkStoredIndex] = newDrink
    this.props.onChange(selectedDrinks.filter(dr => dr.count > 0))
    // this.props.onChange({...this.props.value, [id]: Math.max(0, (this.props.value[id] || 0) + count)})
  }

  getTotalCount() {
    return this.props.value.map(drink => drink.count).reduce((a, b) => a + b, 0)
  }

  render() {
    const { drinks, persons, value, totalmenus } = this.props
    return  (
      <React.Fragment>

        <div id="DrinksPicker" >
          <div className="topbar">
            <p>
                请选择
              {totalmenus}
                份饮料
            </p>
            <div className="basket">
              <Ionicon icon="ios-basket" size="20px" color="#E12968"  />
              <p>{this.getTotalCount()}</p>
            </div>
          </div>

          <div className="drinksContainer">
            {sortBy(
              values(drinks)
                .filter(drink => drink.isInMenus == true),
              "order"
            )
              .map(drink => {
                const drinkStored = find(
                  value, 
                  (dr) => drink.id == dr.id
                )
                return (
                  <div key={drink.id} className="drink">
                    <div
                      className="drinkimage"
                      style={{
                        backgroundImage: `url(${drink.background.image})`,
                      }}
                    />
                    <div className="texts">
                      <div className="drinktitle">{drink.chName}</div>
                      <div className="drinkdescription">{drink.description}</div>
                    </div>
                    <div className="buttonGroup">
                      {drinkStored && drinkStored.count > 0 && (
                        <React.Fragment>
                          <div 
                            className="countButton delete"
                            onClick={event => {
                              event.stopPropagation()
                              this.changeCount(drink, -1)
                            }}
                          >
                            <Ionicon icon="md-remove" size="40px" color="white"  />
                          </div>
                          <div className="count">{drinkStored ? drinkStored.count : 0}</div>
                        </React.Fragment>
                      )}
                      <div 
                        className={`countButton ${this.getTotalCount() >= totalmenus ? "disabled" : ""}`}
                        disabled={this.getTotalCount() >= totalmenus}
                        onClick={event => {
                          if (this.getTotalCount() < totalmenus) {
                            event.stopPropagation()
                            this.changeCount(drink, 1)
                          }
                        }}
                      >
                        <Ionicon icon="md-add" size="40px" color="white"  />
                      </div>
                    </div>
                  </div>
                ) 
              })}
          </div>
        </div>
      </React.Fragment>
      
    )
  }
}

DrinksPicker.propTypes = {
  drinks: PropTypes.arrayOf(PropTypes.object).isRequired, 
  persons: PropTypes.number.isRequired, 
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func, 
}


// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/Reservation.Drinks.jsx